module.exports = require("@swa-ui/core/src/ListScroller/ListScroller.module.scss");